import { motion } from "framer-motion";
import { Heart } from "lucide-react";

export default function HeartBurst() {
  const hearts = [...Array(14)].map((_, i) => ({
    id: i,
    x: -130 + Math.random() * 260,
    y: -(180 + Math.random() * 260),
    scale: 0.7 + Math.random() * 1.1,
    rotate: -40 + Math.random() * 80,
    delay: i * 0.06,
  }));

  return (
    <div className="pointer-events-none absolute inset-0 overflow-visible">
      {hearts.map((h) => (
        <motion.span
          key={h.id}
          initial={{ opacity: 1, x: 0, y: 0, scale: 0.3, rotate: 0 }}
          animate={{ opacity: 0, x: h.x, y: h.y, scale: h.scale, rotate: h.rotate }}
          transition={{ duration: 1.8, delay: h.delay, ease: "easeOut" }}
          className="absolute left-1/2 top-1/2 text-[#E11D48]"
        >
          <Heart className="h-5 w-5 fill-current" />
        </motion.span>
      ))}
    </div>
  );
}
